import { BaseSeasonCardElementMixin } from "%/dynamic-component-editor/standard-components/base-season-card/base-season-card-element-mixin";

// Mirrors ShowPageElementMixin — routes Season* elements through the
// season-store + pageEntities wiring so production renders real data
// against the URL-derived season_id.
export const SeasonPageElementMixin = {
  extends: BaseSeasonCardElementMixin,
};
